import React from 'react';

import { Languages } from '../../components/languages';
import {
    ajax, plainDate, getNavigation, manageOrderStock,
    buildManageOrderStockDto, /*buildManageStockAddress,*/ downloadCsv, loadAutocompleteCountries, /*autoCompleteForeignCitiesForCountry,*/
    /*ProfileLevels*/
} from '../../components/globals';
import { Roles } from '../../auth/rolesPermissions';
import {
    numberValidation, nameValidation, emailValidation, emptyValidation,
    validate
} from '../../components/validate';
import { InputColumn } from '../../components/utilities';
import { UISummary, UIFilterPanel, UISummaryWidget, UISummaryWidgetBar, PageTitle, UIDataTable, UIDownload, UIPopup, UIInput, UIButton, UICheckbox, UISelect } from '../../components/guiElements';
import { FieldProps } from '../../components/fieldProps';
import { v4 as uuidv4 } from 'uuid';

export default class WarehouseReturnProducts extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return null;
    }
}